export default "__VITE_ASSET__D0Y5TLXd__"